import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OBResponse, OnboardingEndpointsService } from './onboarding-endpoints.service';
import { rutValidate } from 'rut-helpers';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { gtpRutValidator } from 'src/app/shared/validators/rut-validator';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TermsModalComponent } from './terms-modal/terms-modal.component'
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { CognitoService, IUserInfoCognito } from 'src/app/shared/services/cognito.service';
import { environment } from 'src/environments/environment';
import { rutClean } from 'rut-helpers';
import { Store } from '@ngrx/store';
import { selectUserInfo } from 'src/app/state/selectors/userInfo.selectors';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss']
})
export class OnboardingComponent implements OnInit {

  isLoading = false;

  rutControl: FormControl = new FormControl('', [Validators.required, gtpRutValidator()]);
  siiControl: FormControl = new FormControl('', [Validators.required]);
  onboardingForm: FormGroup = new FormGroup([])

  public userInfo: IUserInfoCognito | null = null;
  private _userInfo$: Observable<IUserInfoCognito> = this.store.select(selectUserInfo);

  constructor(
    private _endpointService: OnboardingEndpointsService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private _cognitoService: CognitoService,
    private store: Store

  ) { }

  ngOnInit(): void {
    this._userInfo$.subscribe((userInfo) => {
      this.userInfo = userInfo;
    })
    this.onboardingForm = this.formBuilder.group({
      rut: this.rutControl,
      sii: this.siiControl
    });
  }

  public rutValidate(event: any) {
    if (!rutValidate(event)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  formatRut(rut: string) {
    if (rut && rut.length > 0 && rut[rut.length - 2] !== '-') {
      // Add '-' before the last character
      return rut.slice(0, -1) + '-' + rut.slice(-1);
    }
    return rut;
  }

  onEnviar() {
    const userInfo = this.userInfo;

    if(userInfo) {
      const userMail = userInfo.email;
      // this.spinner.show();
      this.isLoading = true;

      let cleanRut = rutClean(this.rutControl.value)
      let formattedRut = this.formatRut(cleanRut)
      this._endpointService.startOnboarding(userMail, formattedRut, this.siiControl.value).subscribe(
        (response1: OBResponse) => {
          if(response1.IDTransaccion){
            this.callStep2(userMail, formattedRut, this.siiControl.value, response1.IDTransaccion, 0);
          }
        },
        (error: { status: number; error: any; }) => {
          // Handle a 500 Internal Server Error response here
          if (error.status === 500) {
            // Execute code for a 500 response
            console.error('Server error: ', error.error);
            this.toastr.error(error.error.message, 'Error en el onboarding');
            //mostrar algun mensaje de error
          } else if (error.status === 401){
            this.toastr.error(error.error.message, 'No tienes permiso para realizar esta operación');
          } else {
            this.toastr.error('Error inesperado', 'Vuelva a intentar mas tarde');
          }
          this.isLoading = false;
        }
      );
    }
  }


  callStep2(userName: string, organization: string, sii: string, idTransaccion: string, tries: number){
    // console.log('intento', tries++);
    this._endpointService.onBoardingStep2(userName, organization, this.siiControl.value, idTransaccion).subscribe(
      (response2: OBResponse) => {
        //agrego la empresa al store
        this.isLoading = false;
        this.toastr.success('', 'Onboarding exitoso');     
        // this.router.navigate(['/landing-empresa'])

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          data: {
              title: 'Nueva empresa',
              message: `El onboarding de tu empresa se ha realizado con exito, ahora debes volver a logearte para poder visualizar sus datos.`,
              textBoton: ['Ok'],
              textTimer: environment.inactivity.countdown + 1,
              hideCancelmButtom: true
          }
        });
  
        dialogRef.afterClosed().subscribe(() => {
          this._cognitoService.logout();
        });
      },
      (error: any) => {
        console.error('Server error: ', error);

        if(error.error.message == 'Basic Report - Timeout al llamar a servicio de obtención de razon social' || error.status == 504) {
          //reintento 2 veces
          if(tries < 3){
            this.callStep2(userName, organization, this.siiControl.value, idTransaccion, tries++);
          } else {
            console.error(error.error.message);
            this.toastr.error('Error en el onboarding', error.error.message);
          }
        } else {
          console.error(error.error.message);
          this.toastr.error('Error en el onboarding', error.error.message);
        }

        this.isLoading = false;
      }
    )
  }

  seeTerms() {
    this.dialog.open(TermsModalComponent, {
      data: {}
    });
  }
}


